import { render, staticRenderFns } from "./NotificacaoFd.vue?vue&type=template&id=d31c5fc2&"
import script from "./NotificacaoFd.vue?vue&type=script&lang=js&"
export * from "./NotificacaoFd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports